/**
 * Service detail page -- /twin/service/:id (P2.7.e).
 *
 * Round 10 C4: the page's parts read the same query now. The reach
 * sentence landed in round 9 and everything around it kept answering
 * from its own: eight findings reach this service through its
 * configuration items, and eight lines below "No open findings on this
 * entity"; three named business services, and three lines below
 * "IBSES n/a".
 */
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { EntityDetailLayout } from "twin/entity/EntityDetailLayout";
import { ServiceClassificationPanel } from "twin/entity/ServiceClassificationPanel";
import { ServiceReachPanel } from "twin/entity/ServiceReachPanel";
import { useServiceReach } from "twin/entity/useServiceReach";

export function ServiceDetail() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const reach = useServiceReach(id);

  const chips = {
    resilience: null,
    // The three business services the page NAMES, in the tile that used
    // to print "n/a" beside them.
    blast_ibs_count: reach.data ? reach.data.ibses.length : null,
    // Still unanswered by this page, and now omitted rather than
    // printed as a confident "n/a".
    process_count: null,
    obligation_count: null,
  } as const;

  return (
    <EntityDetailLayout
      kind="service"
      entityId={id}
      chips={chips}
      findingsEmpty={
        reach.data && reach.data.findings_via_configuration_items > 0
          ? t("modules.twin.entity.reach.noneDirectHere", {
              count: reach.data.findings_via_configuration_items,
            })
          : undefined
      }
      // B2 -- the classification ceremony's own record, on the page the
      // ceremony deep-links to.
      story={
        id ? (
          <div className="space-y-4">
            {/* Round 9 C1: what reaches it, and what it holds up --
                the two questions the page answered from nothing. */}
            <ServiceReachPanel serviceId={id} />
            <ServiceClassificationPanel serviceId={id} />
          </div>
        ) : null
      }
    />
  );
}
